<div fxFlex fxFlexFill fxLayout="column" class="container-fluid" *ngIf="!isPerspayAny">
  <div class="state" role="group">
    <div class="card" class="fxGap-medium-sm">
      <div class="card-body" fxLayout="column" *ngIf="step === 0">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="mgbt-small" *ngIf="isSOE">
            <h2 role="heading" class="mobile-text-centered mgtp-x-small mgbt-medium-sm">Special open enrollment events</h2>
        </div>
        <soe-instructions *ngIf="isSOE" isSelfPay="true"
          [subscriber]="subscriber"
          [isCobra]="isCobraMemberType"
          [isRetiree]="isRetireeMemberType"
          [isLwop]="isUnpaidMemberType" 
        ></soe-instructions>
        <ng-container *ngIf="!isSOE">
          <div class="ie-height-mobile-l hca-dashboard-card-container" fxLayout="row wrap">
            <div class="hca-dashboard-card" fxFlex.xs="100%">
              <div class="card-body">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <h2 role="heading" class="mobile-text-centered mgtp-small">PEBB Retiree insurance coverage</h2>
                </div>
                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                  <div *ngIf="continuationCoverageAvailable" fxLayout="column" [fxFlex]="hasApprovedRequest ? 100 : 75"
                    class="mgbt-small">
                    <ul>
                      <li>
                        PEBB retiree insurance coverage is available to more than only employees who are retiring. It may also include separated employees who are at least 55 years of age and meet specific retirement plan and years of service requirements and who will not yet receive a monthly retirement plan payment. As a retiring or separating employee, if you meet procedural and eligibility requirements, you can enroll in PEBB retiree insurance coverage, which offers a range of medical and dental plans to choose from as well as vision plans for non-Medicare members, and retiree term life insurance.
                      </li>
                      <li>
                        If you meet the eligibility requirements and you're not ready to enroll in PEBB retiree insurance coverage because you are enrolled in Medicare and permanently reside outside of the United States, or you have other qualified medical coverage, such as employer health coverage through your spouse or state-registered domestic partner, you may choose to defer (postpone) enrollment. When you defer, you are postponing enrollment in medical, dental, and vision coverage. Deferring your enrollment will retain your eligibility in case you want to enroll later.   
                      </li>
                    </ul>
                  </div>
                  <div *ngIf="!isSOE && canAdd && hasRetiree && !hasApprovedRequest" fxLayout="column"
                    class="form-group" fxFlex="25" fxLayoutAlign="top center">
                    <button type="submit" class="btn btn-primary" (click)="addRetiree()">
                      Create Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ie-height-mobile-l hca-dashboard-card-container" fxLayout="row wrap">
            <div class="hca-dashboard-card" fxFlex.xs="100%">
              <div class="card-body">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <h2 *ngIf="isPEBB" role="heading" class="mobile-text-centered mgtp-small">
                    {{currentOrganizationAgencyCode}} Continuation Coverage (COBRA/Employer Group Ended Participation)
                  </h2>
                  <h2 *ngIf="!isPEBB" role="heading" class="mobile-text-centered mgtp-small">
                    {{currentOrganizationAgencyCode}} Continuation Coverage (COBRA)
                  </h2>
                </div>
                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                  <div *ngIf="continuationCoverageAvailable" fxLayout="column" [fxFlex]="hasApprovedRequest ? 100 : 75"
                    class="mgbt-small">
                    <ul>
                      <li>
                        {{currentOrganizationAgencyCode}} Continuation Coverage (COBRA) is a temporary extension of
                        {{currentOrganizationAgencyCode}} health plan coverage
                        available to {{currentOrganizationAgencyCode}} members who are qualified beneficiaries under
                        federal Consolidated Omnibus Budget Reconciliation Act (COBRA) rules<ng-container *ngIf="isPEBB">, and to a retiree and
                        their dependents, or other eligible subscriber who lose eligibility.</ng-container>
                        <ng-container *ngIf="!isPEBB"> and to school board members and their dependents who lose eligibility.</ng-container>
                      </li>
                      <li>
                        HCA also extends {{currentOrganizationAgencyCode}} Continuation Coverage (COBRA) to
                        state-registered domestic partners and their children, based on RCW 26.60.015 and
                        {{currentOrganizationAgencyCode}} policy resolution that extends {{currentOrganizationAgencyCode}}
                        coverage for dependents not otherwise eligible for COBRA. Coverage may be temporarily
                        extended only if the {{currentOrganizationAgencyCode}} member experiences a qualifying event.
                      </li>
                      <li *ngIf="isPEBB">
                        {{currentOrganizationAgencyCode}} Continuation Coverage (Employer Group Ended Participation) is an
                        extension of {{currentOrganizationAgencyCode}} health plan coverage available to a retired employee
                        or retired school employee of an employer group who lost eligibility for PEBB retiree insurance coverage
                        due to their employer group ending participation in Public Employee Benefits Board (PEBB) or
                        School Employee Benefits Board (SEBB) insurance coverage.
                      </li>
                    </ul>
                  </div>
                  <div *ngIf="!isSOE && canAdd && hasCobra && !hasApprovedRequest" fxLayout="column" class="form-group"
                    fxFlex="25" fxLayoutAlign="top center">
                    <button type="submit" class="btn btn-primary" (click)="addCobra()">
                      Create Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ie-height-mobile-l hca-dashboard-card-container" fxLayout="row wrap">
            <div class="hca-dashboard-card" fxFlex.xs="100%">
              <div class="card-body">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <h2 role="heading" class="mobile-text-centered mgtp-small">{{currentOrganizationAgencyCode}}
                    Continuation Coverage (Unpaid Leave)</h2>
                </div>
                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                  <div *ngIf="continuationCoverageAvailable" fxLayout="column" [fxFlex]="hasApprovedRequest ? 100 : 75"
                    class="mgbt-small">
                    <ul>
                      <li>
                        {{currentOrganizationAgencyCode}} Continuation Coverage (Unpaid Leave) is a temporary extension
                        of {{currentOrganizationAgencyCode}} insurance coverage for employees who lose eligibility for
                        the employer contribution toward {{currentOrganizationAgencyCode}} benefits due to specific
                        types of leave.
                      </li>
                    </ul>
                    <a *ngIf="!subscriber.isSebb" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage"
                      target="_blank">Learn more about PEBB Continuation Coverage</a>
                    <a *ngIf="subscriber.isSebb"
                      href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage"
                      target="_blank">Learn more about SEBB continuation coverage</a>
                  </div>
                  <div *ngIf="!isSOE && canAdd && hasLwop && !hasApprovedRequest" fxLayout="column" class="form-group"
                    fxFlex="25" fxLayoutAlign="top center">
                    <button type="submit" class="btn btn-primary" (click)="addLwop()">
                      Create Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="step === 0 && (isSOE || (subscriber?.selfPays && subscriber.selfPays.length))" fxLayout="column"
        fxLayoutAlign="center center">
        <h3 class="h4">Select the check-box to the left to manage the
          <span class="h4" *ngIf="isSOE">event and/or</span>
          <span class="h4" *ngIf="!isSOE">coverage request and</span> view related forms
        </h3>
        <div class="pad-std-container">
          <self-pay-grid #selfPayGridControl (downloadCoveragePDF)="downloadCoveragePDF($event)"
            (downloadSelfPayPDF)="downloadSelfPayPDF($event)" (removeSelfPay)="deleteSelfPay($event)"
            (editSelfPay)="editSelfPay($event)" [selfPays]="subscriber?.selfPays" [isReadOnly]="isReadOnly"
            [isPerspay]="isPerspay" [isHcaEdit]="isHcaEdit" [isSOE]="isSOE"></self-pay-grid>
        </div>
        <div class="pad-std-container" fxFlexFill>
          <self-pay-add #selfPayAdd *ngIf="!isReadOnly && (isSOE || hasApprovedRequest)"
            [selfPayVerificationStatus]="lookups.selfPayVerificationStatus"
            [currentOrganizationAgencyCode]="currentOrganizationAgencyCode" [canAdd]="canAdd" [isSOE]="isSOE"
            [subscriber]="subscriber" (saveSelfPay)="saveSelfPay($event)" class="mgtp-medium mgbt-medium"
            [selfPayTypes]="selfPayTypeList"></self-pay-add>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center">
        <ng-container *ngIf="soeCustomForm && selectedSelfPay && step === 1">
          <self-pay-change-of-address *ngIf="selectedSelfPay?.selfPayType?.selfPayTypeCode=='SOEA'" fxFlexFill
            [subscriber]="subscriber" [selectedSelfPay]="selectedSelfPay" [currentDependents]="currentDependents"
            (saveSelfPay)="saveSelfPay($event,true)" (previous)="previous()">
          </self-pay-change-of-address>
        </ng-container>
        <ng-container
          *ngIf="!soeCustomForm">
          <div *ngIf="formPages[step - 1] === 'showAdminPrompt'" fxLayout="column" class="fxGap-large"
            style="padding-bottom: 100px">
            <h2 class="prompt-question">Would you like to opt-out of completing the {{
              selectedSelfPay?.selfPayType?.selfPayTypeName }} form?</h2>
            <div fxLayout="row" fxLayoutAlign="space-between">
              <yes-no name="optOut" style="margin-bottom: 30px; padding: 0 75px;" [(ngModel)]="proceedThroughWiz"
                (change)="proceed(proceedThroughWiz)"></yes-no>
            </div>
          </div>
          <self-pay-info *ngIf="formPages[step - 1] === 'self-pay-info'" 
            [agency]="selectedSelfPay?.agency?.agencyCode"
            [selfPay]="selectedSelfPay"
            [requestType]="selectedSelfPay.selfPayType"
            [specialOpenEnrollmentTypes]="lookups.specialOpenEnrollmentTypes"
            [selectedSpecialOpenEnrollmentTypeId]="selectedSelfPay.specialOpenEnrollmentTypeId"
            (selectedSpecialOpenEnrollmentType)="selectedSelfPay.specialOpenEnrollmentTypeId = $event?.specialOpenEnrollmentTypeId"
            (continue)="continue()" (previous)="previous()"
            [subscriber]="subscriber"
          ></self-pay-info>
          <self-pay-payment *ngIf="formPages[step - 1] === 'self-pay-payment'" [agency]="selectedSelfPay?.agency?.agencyCode"
            [requestType]="selectedSelfPay.selfPayType" [selfPayPaymentType]="selectedSelfPay.selfPayPaymentType"
            [selectedSelfPay]="selectedSelfPay" [subscriber]="subscriber"
            (saveSelfPayPaymentOption)="updatePaymentOption($event)" (previous)="previous()"></self-pay-payment>
          <self-pay-reason *ngIf="formPages[step - 1] === 'self-pay-reason'"
            [selfPay]="selectedSelfPay" (saveSelfPayReason)="saveSelfPay($event)"
            (previous)="previous()"></self-pay-reason>
          <self-pay-subscriber *ngIf="formPages[step - 1] === 'self-pay-subscriber'"
            [selfPay]="selectedSelfPay" [subscriber]="subscriber"
            [lookups]="lookups" [isPerspay]="isPerspay" (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [ltdAvailablePlans]="activePlans"></self-pay-subscriber>

          <self-pay-dependent *ngIf="formPages[step - 1] === 'self-pay-dependent'"
            [agency]="selectedSelfPay?.agency?.agencyCode" (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [selfPay]="selectedSelfPay" [currentDependents]="currentDependents" [lookups]="lookups"></self-pay-dependent>
          <self-pay-elect-medical fxFill [agency]="selectedSelfPay?.agency" [ethnicities]="ethnicities"
            *ngIf="formPages[step - 1] === 'self-pay-elect-medical'"
            (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [selfPay]="selectedSelfPay"
            [subscriber]="subscriber"
            [availablePlans]="activePlans" 
            [lookups]="lookups"></self-pay-elect-medical>

          <self-pay-elect-dental fxFill [agency]="selectedSelfPay?.agency"
            *ngIf="formPages[step - 1] === 'self-pay-elect-dental'"
            (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [selfPay]="selectedSelfPay"
            [subscriber]="subscriber"
            [availablePlans]="activePlans"></self-pay-elect-dental>
          <self-pay-elect-vision fxFill [agency]="selectedSelfPay?.agency"
            *ngIf="formPages[step - 1] === 'self-pay-elect-vision'"
            (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [selfPay]="selectedSelfPay"
            [subscriber]="subscriber"
            [availablePlans]="activePlans"></self-pay-elect-vision>
          <self-pay-upload fxFill *ngIf="formPages[step - 1] === 'self-pay-upload'"
            (refetchSelfPay)="refetchSelfPay($event)" (saveSelfPay)="saveSelfPay($event)" (previous)="previous()"
            [selfPay]="selectedSelfPay" [agency]="selectedSelfPay?.agency?.agencyCode"
            [documentTypes]="lookups.documentType" [isRetiree]="hasRetiree" [subscriber]="subscriber"></self-pay-upload>
          <self-pay-confirm (downloadPDF)="downloadSelfPayPDF()" *ngIf="formPages[step - 1] === 'self-pay-confirm'"
            (saveSelfPay)="saveSelfPay($event, true)" (previous)="previous()" [selfPay]="selectedSelfPay"
            [agency]="selectedSelfPay?.agency?.agencyCode"
            [requestType]="selectedSelfPay.selfPayType"></self-pay-confirm>
        </ng-container>
      </div>
    </div>
    <div fxFlexFill fxLayout="row" fxLayoutAlign="center center">
      <button style="margin: 30px" (click)="navToDashboard()" class="btn btn-secondary">Back to dashboard</button>
    </div>
    <div>
      <pdf #selfPayPDF *ngIf="selectedSelfPay"
        [documentTitleText]="selectedSelfPay?.agency?.agencyCode + ' ' + capitalize(selectedSelfPay.selfPayType?.selfPayTypeName)"
        [documentHeaderText]="formHeaderText" [containerClass]="pdfContainerClass" aria-hidden="true">
        <self-pay-pdf *ngIf="!soeCustomForm" [selfPay]="selectedSelfPay"
          [selfPayPaymentTypes]="lookups.selfPayPaymentType" [birthSexes]="lookups.birthSexes"
          [genderIdentities]="lookups.genderIdentities" [availablePlans]="availablePlans" [ethnicities]="ethnicities"
          [lookups]="lookups">
        </self-pay-pdf>
        <self-pay-custom-form-pdf *ngIf="soeCustomForm" [selfPay]="selectedSelfPay">
        </self-pay-custom-form-pdf>
      </pdf>
    </div>
  </div>
</div>